import { render, staticRenderFns } from "./TopGoldCompanies.vue?vue&type=template&id=d3e39810&"
import script from "./TopGoldCompanies.vue?vue&type=script&lang=js&"
export * from "./TopGoldCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports